import React from 'react';
import { IconButton, Tooltip } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  type?: 'unclicked' | 'focus-off' | 'warning';
  id?: string;
  onClick?: () => void;
  iconSize?: number;
  size?: string;
  variant?: string;
}

const EditDataIcon: React.FC<Props> = ({ type = 'unclicked', id, onClick, size = 'lg', variant = 'secondary' }) => {
  const getButtonProps = (): { label: string } => {
    if (type === 'warning') {
      return { label: 'Requires attention' };
    }
    return {
      label: 'Edit',
    };
  };
  const { label } = getButtonProps();

  return (
    <>
      <Tooltip hasArrow placement="top" label={label}>
        <IconButton
          data-selector={id}
          onClick={onClick}
          aria-label={label}
          icon={<FontAwesomeIcon id={id || 'icon'} icon={faEdit} />}
          size={size}
          variant={variant}
        />
      </Tooltip>
    </>
  );
};

export { EditDataIcon };
